import { boot } from 'quasar/wrappers'
import { defineCustomElements } from '@stripe-elements/stripe-elements/loader';

export default boot(async ({ app }) => {
await defineCustomElements();
})
